import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';
import { Game } from 'chessboard/model/game/types';
import { initial as initialFEN } from 'test/mocks/fens';

/**
 * Create the resetGame method.
 */
export function createResetGame(context: API.Context) {
  /**
   * Reset the game.
   */
  return function resetGame(): API.Response {
    const { api, respond } = context;

    api.setResult(Game.Results.None);

    api.load({ fen: initialFEN });

    return respond(Core.APIEvents.ResetGame);
  };
}
